__turbopack_context__.v({
  "iframe": "vario-video-module__Ib5h1q__iframe",
});
